import {CountriesWithCurrencies} from '../../commons/data/countiresWithCurrencies';

export const useCountryInfoHook = (suggestedCurrencyCode: string) => {
  const userCountryInfo = CountriesWithCurrencies.find((c) => c.currency === suggestedCurrencyCode);

  return {
    userCountryInfo,
  };
};
